export const SPACELIFT_VCS_REPO_COMMIT_SEARCH_FILTERS_STORAGE_KEY =
  "spaceliftVcsRepoCommitSearchFilters";

export const DIFF_EDITOR_OPTIONS = {
  glyphMargin: false,
  readOnly: true,
  scrollBeyondLastLine: false,
  scrollbar: {
    verticalScrollbarSize: 4,
    horizontalScrollbarSize: 4,
    alwaysConsumeMouseWheel: false,
  },
  unicodeHighlight: {
    invisibleCharacters: false,
  },
  minimap: { enabled: false },
  renderSideBySide: false,
} as const;

export const LINE_HEIGHT = 19;
export const MAX_EDITOR_HEIGHT = 500;
export const PADDING = 26;
